import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/accept-company-invitation`, data)

    return result.data
}

export default service
